import { c as create_ssr_component, b as add_attribute } from "./ssr.js";
const Input = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { value = "" } = $$props;
  let { id } = $$props;
  let { type = "text" } = $$props;
  let { name } = $$props;
  let { required = false } = $$props;
  let { inputRef = null } = $$props;
  let { placeholder = "" } = $$props;
  if ($$props.value === void 0 && $$bindings.value && value !== void 0)
    $$bindings.value(value);
  if ($$props.id === void 0 && $$bindings.id && id !== void 0)
    $$bindings.id(id);
  if ($$props.type === void 0 && $$bindings.type && type !== void 0)
    $$bindings.type(type);
  if ($$props.name === void 0 && $$bindings.name && name !== void 0)
    $$bindings.name(name);
  if ($$props.required === void 0 && $$bindings.required && required !== void 0)
    $$bindings.required(required);
  if ($$props.inputRef === void 0 && $$bindings.inputRef && inputRef !== void 0)
    $$bindings.inputRef(inputRef);
  if ($$props.placeholder === void 0 && $$bindings.placeholder && placeholder !== void 0)
    $$bindings.placeholder(placeholder);
  return `<input autocomplete="off"${add_attribute("placeholder", placeholder, 0)}${add_attribute("name", name, 0)}${add_attribute("id", id, 0)} ${required ? "required" : ""} class="border rounded-full focus focus:border-gray-800 focus:ring-gray-800 py-3.5 px-5"${add_attribute("value", value, 0)}${add_attribute("this", inputRef, 0)}>`;
});
export {
  Input as I
};
